import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SelectedSignatoryDetails } from 'appRootPath/models/commercial-papers.model';

// 30 seconds
export const DEFAULT_POLL_INTERVAL = 30000;
// 5 minutes
export const IPA_POLL_INTERVAL = 300000;
// OTP Resend Interval in seconds:  4 mins = 240 seconds
export const OTP_RESEND_INTERVAL = 240;

export const ISSUER_STATE_ROLE_AUCTION = 27;
export const INVESTOR_STATE_ROLE_AUCTION = 28;

export const RUPEE_CODE = 'INR';
export const RUPEE_SYMBOL = '₹';


// eslint-disable-next-line no-shadow
export enum InstrumentEnum {
  COMMERCIAL_PAPER = 1
}

// eslint-disable-next-line no-shadow
export enum CpRolesEnum {
  ISSUER = 1,
  IPA,
  INVESTOR
}

// eslint-disable-next-line no-shadow
export enum AuctionPrivacyEnum {
  OPEN = 1,
  SECRET
}

// eslint-disable-next-line no-shadow
export enum IssueVisibilityEnum {
  PUBLIC = 1,
  CUSTOM
}

export const CustomAuctionPrivacyTypes = {
  WHITELIST: 'whitelist',
  BLACKLIST: 'blacklist'
};

export const INSTRUMENTS_MAP = {
  [InstrumentEnum.COMMERCIAL_PAPER]: 'Commercial Papers'
};

export const ROLES_MAP = {
  [CpRolesEnum.INVESTOR]: 'Investor',
  [CpRolesEnum.IPA]: 'IPA',
  [CpRolesEnum.ISSUER]: 'Issuer'
};

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const ISO_DATE_STRING = 'iso';

export const UI_DATE_FORMAT_MAP = {
  default: 'Do MMM\'YY',
  full: 'DD MMM\'YY hh:mm A',
  full_seconds: 'DD MMM\'YY hh:mm:ss A'
};

// All amounts should be multiples of 5 lakhs.
export const CP_MIN_BID_VALUE_FACTOR = 500000;


export const MODAL_OPTIONS: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false
};

export const SIGNING_MODAL_TYPES = {
  SEND: 'send',
  RESEND: 'resend'
};

export const TENURE_RANGE = {
  min: 7,
  max: 365
};

export const VALUE_DATE_MAX = 14;

// Below Document name constants are the keys which backend uses for identifying documents.
export const MASTER_CREATION_FORM = 'master_creation_form';
export const LETTER_OF_OFFER = 'letter_of_offer';
export const ISSUER_CONFIRMATION_TO_IPA = 'issuer_confirmation_to_IPA';
export const DEAL_CONFIRMATION_NOTE = 'deal_confirmation_note';
export const PROMISSORY_NOTE = 'promissory_note';
export const COVERING_LETTER = 'covering_letter';
export const ELIGIBILITY_LETTER = 'eligibility_letter';
export const RBI_LETTER = 'rbi_letter';
export const IPA_CERTIFICATE = 'ipa_certificate';
export const CP_ALLOTMENT = 'cp_allotment';
export const CORPORATE_ACTION_FORM = 'CAF';
export const CAF_ISSUANCE_LETTER = 'caf_issuance_letter';
export const DEPOSITORY_INPUT_CSV = 'depository_input_csv';
export const BSE_ANNEXURE_A = 'AnnexureAForBSE';
export const BSE_ANNEXURE_B = 'BSEAnnexureBFresh';
export const BSE_ANNEXURE_B_FURTHER = 'BSEAnnexureBFurther';
export const BSE_LIST_OF_INVESTORS = 'BSEListInvestors';
export const BSE_ANNEXURE_IK = 'BSEAnnexureIK';
export const BSE_ANNEXURE_A_FORM_A = 'AnnexureAFormAForBSE';

export const NSE_ANNEXURE_A = 'AnnexureAForNSE';
export const NSE_ANNEXURE_B = 'NSEAnnexureBFresh';
export const NSE_ANNEXURE_B_FURTHER = 'NSEAnnexureBFurther';
export const NSE_LIST_OF_INVESTORS = 'NSEListInvestors';
export const NSE_ANNEXURE_IK = 'NSEAnnexureIK';
export const NSE_ANNEXURE_A_FORM_A = 'AnnexureAFormAForNSE';

export const PROOF_OF_STAMP_PAPER = 'stamp_paper_doc';
export const CAF_CDSL = 'CAF_CDSL';
export const CAF_CDSL_ISSUANCE_LETTER = 'caf_cdsl_issuance_letter';

// Below constant gives the display name for the document.
export const DOCUMENT_NAME_MAP = {
  [MASTER_CREATION_FORM]: 'Master Creation Form',
  [LETTER_OF_OFFER]: 'Letter of Offer',
  [ISSUER_CONFIRMATION_TO_IPA]: 'Issuer Confirmation to IPA',
  [DEAL_CONFIRMATION_NOTE]: 'Deal Confirmation Note',
  [PROMISSORY_NOTE]: 'Promissory Note',
  [COVERING_LETTER]: 'Covering Letter',
  [ELIGIBILITY_LETTER]: 'Eligibility Letter',
  [RBI_LETTER]: 'Letter to RBI',
  [IPA_CERTIFICATE]: 'IPA Certificate',
  [CP_ALLOTMENT]: 'CP Allotment Form',
  [CORPORATE_ACTION_FORM]: 'CAF NSDL',
  [CAF_ISSUANCE_LETTER]: 'CAF NSDL Issuance Letter',
  [DEPOSITORY_INPUT_CSV]: 'Depository Input CSV',
  [BSE_ANNEXURE_A]: 'BSE Annexure A',
  [BSE_ANNEXURE_A_FORM_A]: 'BSE Annexure A Form A',
  [BSE_ANNEXURE_B]: 'BSE Annexure B Fresh',
  [BSE_ANNEXURE_B_FURTHER]: 'BSE Annexure B Further',
  [BSE_LIST_OF_INVESTORS]: 'BSE List Of Investors',
  [BSE_ANNEXURE_IK]: 'BSE Annexure IK',
  [NSE_ANNEXURE_A]: 'NSE Annexure A',
  [NSE_ANNEXURE_A_FORM_A]: 'NSE Annexure A Form A',
  [NSE_ANNEXURE_B]: 'NSE Annexure B Fresh',
  [NSE_ANNEXURE_B_FURTHER]: 'NSE Annexure B Further',
  [NSE_LIST_OF_INVESTORS]: 'NSE List Of Investors',
  [NSE_ANNEXURE_IK]: 'NSE Annexure IK',
  [PROOF_OF_STAMP_PAPER]: 'Proof of Stamp Paper',
  [CAF_CDSL]: 'CAF CDSL',
  [CAF_CDSL_ISSUANCE_LETTER]: 'CAF CDSL Issuance Letter'
};

export const LISTING_DOC_NAME_ID_MAP = {
  [BSE_ANNEXURE_A]: 'bse_annexure_a',
  [BSE_ANNEXURE_A_FORM_A]: 'bse_annexure_a_form_a',
  [BSE_ANNEXURE_B]: 'bse_annexure_b_fresh',
  [BSE_ANNEXURE_B_FURTHER]: 'bse_annexure_b_further',
  [BSE_LIST_OF_INVESTORS]: 'bse_list_investors',
  [BSE_ANNEXURE_IK]: 'bse_annexure_ik',
  [NSE_ANNEXURE_A]: 'nse_annexure_a',
  [NSE_ANNEXURE_A_FORM_A]: 'nse_annexure_a_form_a',
  [NSE_ANNEXURE_B]: 'nse_annexure_b_fresh',
  [NSE_ANNEXURE_B_FURTHER]: 'nse_annexure_b_further',
  [NSE_LIST_OF_INVESTORS]: 'nse_list_investors',
  [NSE_ANNEXURE_IK]: 'nse_annexure_ik',
};

// Below constants are for Signing Options.
export const ONLY_UPLOAD = 'only_upload';
export const ONLY_ESIGN = 'only_esign';
export const UPLOAD_OR_ESIGN = 'upload_or_esign';


export const amtFormatTypes = {
  INDIAN: 'INDIAN',
  WESTERN: 'WESTERN'
};

export const FORM_STATES = {
  HIDDEN: 'hidden',
  CREATE: 'create',
  EDIT: 'edit'
};

export const OTHER_COMPANY = 'OTHERS';

export const STATE_WAIT_SECURITY = 'wait_to_receive_securties';

export const STATE_WAIT_DCN = 'wait_for_post_auction_docs';

export const STATE_WAIT_IPA_CERT = 'verify_IPA_certificate';

/**!ToDo Move below interfaces and types to models folder
 * Task: Jira CP-65
 */
/* Interfaces =================================================================================== */

export interface DocumentObject {
  additional_data: AdditionalDataObject;
  document_name: DocumentName;
  document_url: string;
  investor_company: CompanyObject;
  investor_profile: InvestorProfile;
  is_action_awaited: boolean;
  is_additional_data_added: boolean;
  is_document_generated: boolean;
  is_sent_for_signing: boolean;
  is_signatories_added: boolean;
  is_signed: boolean;
  issuer_company: CompanyObject;
  signatories_list: SelectedSignatoryDetails[];
  signing_option: SigningOptions;
  unique_id: string;
  // Custom Attributes Added on Frontend:
  is_doc_signed: boolean;
  dcnDocs: DocumentObject[];
}

export type SigningOptions = 'upload_or_esign' | 'only_esign' | 'only_upload';

export type DocumentName = 'master_creation_form' | 'letter_of_offer' | 'deal_confirmation_note'
  | 'promissory_note' | 'covering_letter' | 'eligibility_letter' | 'rbi_letter' | 'ipa_certificate'
  | 'cp_allotment' | 'CAF' | 'caf_issuance_letter' | 'depository_input_csv' | 'issuer_confirmation_to_IPA';

export interface CompanyObject {
  aoa: string;
  coa: string;
  coi: string;
  communication_address: string;
  company_address: string;
  company_name: string;
  corporate_id: string;
  cover_letter_head_image: string;
  corporate_identity_number: string;
  created_at: string;
  date_incorporation_company: string;
  gstin: string;
  id: string;
  is_dummy: boolean;
  is_test_account: boolean;
  kyc_status: boolean;
  kyc_updated_on: string;
  left_right: string;
  legal_entity_identifier: string;
  line_of_business: string;
  modified_at: string;
  official_email_address: string;
  official_fax_number: string;
  official_telephone_number: string;
  pan_company: string;
  pan_proof: string;
  place_of_issue: string;
  status: boolean;
  tnc_signed: boolean;
  top_bottom: string;
}

// TODO: Add the investor profile details from document details
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InvestorProfile {
}

export interface AdditionalDataObject {
  document_date: string;
  // DCN
  issue_reference?: string;
  issuer_dealer_name?: string;

  // Promissory Note
  place?: string;
  serial_number?: string;
  stamp_paper_doc?: string;

  // Covering & Eligibility Letters
  additional_doc?: string;
  description?: string;

  // IPA Certificate
  ipa_reference?: string;
}

export interface UserData {
  token: string;
  corporate_profile: CorporateProfile;
  party_profile: PartyProfile;
  status: boolean;
  auth_details: UserAuthDetails;
  user_company: CompanyObject;
  user_id: string;
  non_field_errors: Array<string>;
  roleId?: string;
  roleType?: number;
}

export interface UserAuthDetails {
  email: string;
  id: string;
  mobile_number: string;
  name: string;
  pan: string;
  phone_number: string;
  tnc_signed: boolean;
}
export interface AssociatedInstrumentIf {
  instrument_type: number;
}
export interface CompanyDivisionIf {
  AssociatedInstrument: Array<AssociatedInstrumentIf>;
}

export interface CorporateProfile {
  CompanyDivision: Array<CompanyDivisionIf>;
}

export interface PartyProfile {
  company: CompanyWithDivisions;
  party_profile_data: PartyProfileData;
}

export interface CompanyWithDivisions extends CompanyObject {
  divisions: Division[];
}

export interface Division {
  id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  name: string;
  city: string;
  location: string;
  is_ho: boolean;
  corporate_admin: string;
  instrument: Instrument[];
}

export interface Instrument {
  id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  name: string;
  instrument_type: number;
  division: string;
  roles: Role[];
}

export interface Role {
  id: string;
  status: boolean;
  modified_at: string;
  created_at: string;
  name: string;
  role_type: number;
  instrument: string;
  state_role: StateRole[];
}

export interface StateRole {
  id: string;
  modified_at: string;
  created_at: string;
  status: boolean;
  name: string;
  state_role_type: number;
  role: string;
}

export interface PartyProfileData {
  id: string;
}

export interface ConfirmModalData {
  questionToAsk: string;
  promptText?: string;
  buttons: ConfirmModalButton[];
}

export interface ConfirmModalButton {
  role: 'cancel' | 'confirm' | 'reject';
  name: string;
  handler?: any;
}

export interface CreditRating {
  amount: number;
  conditions_if_any: string;
  created_at: string;
  credit_rating: string;
  credit_rating_document: FileObject;
  credit_support: string;
  date_of_credit_rating: string;
  docdata_board_resolution: string;
  id: string;
  modified_at: string;
  name_of_credit_rating_agency: string;
  status: boolean;
  validity_for_issuance: string;
  validity_for_issuance_expiry_date: string;
  validity_period_for_rating: string;
  validity_period_for_rating_expiry_date: string;
}

export interface FileObject {
  file_key: string;
  file_name: string;
  file_url: string;
}

export interface BoardResolution {
  board_resolution: string;
  borrowing_limit: number;
  cadmin: string;
  created_at: string;
  date_board_resolution: string;
  id: string;
  list_signatories: string;
  modified_at: string;
  remaining_borrowing_limit: number;
  status: boolean;
}

// CP Purpose Dropdown Values:
export const PURPOSE_OTHERS = 'Others';

export const PURPOSE_LIST = [
  'Rolling over of existing CP',
  'For Repayment of Debt',
  'For Working Capital Requirements',
  'Onward lending to clients',
  'Onward lending to clients for IPO',
  'Reducing Funding Cost',
  PURPOSE_OTHERS
];

export type LoginFormData = {
  password: string;
  otp: string;
  temp_session_id: string;
};
